
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import MFASetup from "@/components/Login/MFASetup.vue"

import api from "@/services/api"
import { User } from "@/types"
import { AccountDetails, AuthSetup, CurrentUser } from "@/types/user"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"mfa-setup": MFASetup
	}
})
export default class AccountSetup extends Vue {
	@Prop({ default: null })
	me!: CurrentUser | null

	private accountDetails: AccountDetails | null = null

	private mfaSetupOpen: boolean = false

	private newAuthDetails: AuthSetup | null = null
	private localAuthCode: string | null = null

	private redirectMFAUrl: string | null = null

	error: any = null

	mounted () {
		this.loadAccountDetails()
		this.loadSuiteMFARedirectUrl()
	}

	loadAccountDetails () {
		api.accountDetails().then(details => this.accountDetails = details)
	}

	async loadSuiteMFARedirectUrl () {
		this.redirectMFAUrl = await api.getMfaRedirectUrl()
	}

	async setMfa () {
		if (!this.newAuthDetails) {
			return
		}

		try {
			await api.setMfa(this.newAuthDetails)
			this.mfaSetupOpen = false
			this.loadAccountDetails()

			this.$bvToast.toast("Two-Factor Authentication Added", {
				title: "Added",
				variant: "success",
				solid: true,
				autoHideDelay: 5000
			})
		} catch (err) {
			this.error = err
		}
	}

	async removeMfa () {
		if (!this.localAuthCode) {
			return
		}

		try {
			await api.removeMfa({
				authCode: this.localAuthCode
			})
			this.mfaSetupOpen = false
			this.loadAccountDetails()

			this.$bvToast.toast("Two-Factor Authentication Removed", {
				title: "Removed",
				variant: "success",
				solid: true,
				autoHideDelay: 5000
			})
		} catch (err) {
			this.error = err
		}
	}

	showMfaForm () {
		if (this.accountDetails && this.accountDetails.isSuiteUser) {
			window.location.href = this.redirectMFAUrl + "?page=" + encodeURIComponent(window.location.href)
		} else {
			this.mfaSetupOpen = true
		}
	}
}

